



















































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { Gender, RiskLevelForScore, RiskTextForScore } from "@/model/Model";
import { RiskLevel } from "@/model/RiskLevel";
import { Borough } from "@/model/Boroughs";

@Component
export default class ThankYouPage extends Vue {
  public static omitFromNavigation: boolean = true;
  public static navButtonLabel: () => string = () => "Thank you page";

  @Prop() public score!: number;
  @Prop() public units!: number;
  @Prop() public calories!: number;
  @Prop() public gender!: Gender;
  @Prop() public region!: Borough;
  @Prop() public isMobile!: boolean;

  private get isHigherRisk(): boolean {
    return RiskLevelForScore(this.score) === RiskLevel.Higher;
  }

  private get isHighRisk(): boolean {
    return RiskLevelForScore(this.score) === RiskLevel.High;
  }

  private get riskText(): string {
    return RiskTextForScore(this.score);
  }

  @Emit("navigate")
  private gotoFindSupport(e: MouseEvent) {
    e.preventDefault();
    return "find-support";
  }

  @Emit("navigate")
  private gotoOnlineAppointment(e: MouseEvent) {
    e.preventDefault();
    return "online-appointment";
  }

  @Emit("navigate")
  private gotoRetakeTest(e: MouseEvent) {
    e.preventDefault();
    return "retake-test";
  }
}
